import React, { useState, useEffect, useContext } from 'react'
import {
    Row,
    Col,
    Card,
    CardBody,
    CardTitle,
    CardFooter
} from 'reactstrap'
import Moment from 'moment'
import { withRouter } from 'react-router-dom'
import toastr from 'toastr'
import 'toastr/build/toastr.min.css'
import { GeneralContext } from '../../../context/'
import ApiService from '../../../data/services/ApiService'
import CurrencyFormat from 'react-currency-format'
import Sidemodal from '../../../components/Sidemodal'
import View from './View'
import Export from './Export'
import { connect } from "react-redux"

const Table = (props) => {
    const generalContext = useContext(GeneralContext)
    const { setLoading } = generalContext

    const [modalOpen, setModalOpen] = useState(false)
    const [currentSalesOrderId, setCurrentSalesOrderId] = useState()
    const [filteredData, setFilteredData] = useState([])
    const [exportModalOpen, setExportModalOpen] = useState(false)

    const handleExport = async (params) => {
        try {
            await ApiService.exportSalesOrders(params)
        } catch (err) {
            if (err.response && err.response.data && err.response.data.code === 'NO_ORDERS_FOUND') {
                toastr.warning(err.response.data.message || 'No se encontraron pedidos para los filtros seleccionados')
            } else {
                toastr.error('Error al exportar pedidos')
            }
        }

        setExportModalOpen(false)
    }

    useEffect(() => {
        (async () => {
            await _fetchData()
        })()
    }, []) // eslint-disable-line

    const _fetchData = async () => {
        setLoading(true)
        try {
            const response = await ApiService.getSalesOrders()

            setFilteredData(response.data.sales)
            setLoading(false)
        } catch (error) {
            console.log(error)
            toastr.error(`No pude encontrar pedidos`)
        } finally {
            setLoading(false)
        }
    }

    const __renderPOView = () => (
        <Sidemodal
            className="xxl"
            title={`Pedido`}
            isOpen={modalOpen}
            onRequestClose={() => {
                setModalOpen(false)
            }}
            body={<View history={props.history} setLoading={setLoading} salesOrderId={currentSalesOrderId} />} />
    )

    const __renderExportView = () => (
        <Sidemodal
            className="sm"
            title={`Exportar Pedidos`}
            isOpen={exportModalOpen}
            onRequestClose={() => {
                setExportModalOpen(false)
            }}
            body={<Export setLoading={setLoading} onExport={handleExport} />} />
    )

    const hasArtistItems = sale => (sale.lineItems || []).some(item => item.categoryType === 'ARTIST')

    return(
        <React.Fragment>
            <Row>
                {filteredData && filteredData.map((item, key) => (
                    <Col key={key} md={4} sm={12} xs={12}>
                        <Card
                            style={{cursor: 'pointer'}}
                            onClick={(e) => {    
                                e.preventDefault()
                                setModalOpen(!modalOpen)
                                setCurrentSalesOrderId(item.id)
                            }}
                        >
                            <CardTitle>
                                <Row>
                                    <Col sm={6}>#P-{item.folio}</Col>
                                    <Col sm={6} style={{ textAlign: 'right' }}>({Moment(item.createdAt).format("DD/MM/YYYY")})</Col>
                                </Row>
                            </CardTitle>

                            <CardBody>
                                <strong>Artículos: </strong> {item.lineItems.length}<br />
                                {hasArtistItems(item) && (
                                    <React.Fragment>
                                        <span className="badge badge-warning">Incluye artista invitado</span><br />
                                    </React.Fragment>
                                )}
                                <strong>Total: </strong><CurrencyFormat decimalScale={2} displayType="text" thousandSeparator prefix="$" value={item.total} /> <br />
                            </CardBody>
                            <CardFooter
                                className={`Sales-order-label-${item.status}`}>
                                <Row>
                                    <Col sm={6}>
                                        <strong>Cliente: </strong> {item.user?.fullName}
                                    </Col>
                                    <Col sm={6} style={{ textAlign: 'right' }}>
                                        <strong>Status: </strong> {item.status}
                                    </Col>
                                </Row>
                            </CardFooter>
                        </Card>
                    </Col>
                ))}
            </Row>

            {modalOpen && __renderPOView()}
            {exportModalOpen && __renderExportView()}
        </React.Fragment>
    )
}

const mapStatetoProps = (state) => {
    return {
        profile: state.Auth.profile
    }
}

export default connect(
    mapStatetoProps, {}
)(withRouter(Table))
